<template>
    <div>
        <v-card class="score-chart ma-2" v-if="!loading">
            <v-container>
                <v-card-title>
                    <span class="caption-font white--text"><v-avatar size="40" class="card_icon mr-4"><v-icon color="white">mdi-home-group-plus</v-icon></v-avatar>Leads</span>
                </v-card-title>
                <span class="br_medium"></span>
                <v-row class="white--text ml-4 mb-6">
                    <table style="width:80%">
                        <tr v-for="lead in leads" :key="lead.key">
                            <td class="td_markup_xl">{{ lead.text }}</td>
                            <td style="text-align: right;" class="td_markup_xl">{{ lead.num }}</td>
                        </tr>
                    </table>
                </v-row>
                <v-divider color="white" v-if="cardActions"></v-divider>
                <v-card-actions v-if="cardActions">
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" icon v-on:click="openAgentDashboard()">
                                <v-icon>mdi-open-in-app</v-icon>
                            </v-btn>
                        </template>
                        <span>My leads</span>
                    </v-tooltip>
                </v-card-actions>
            </v-container>
        </v-card>
    </div>
</template>

<script>
    export default {
        props: {
            agent: {
                type: String,
                requred: false,
                default: "",
            },
            cardActions: {
                type: Boolean,
                requred: false,
                default: true,
            },
        },
        components: {
        },
        data() {
            return {
                timer: null,
                loading: true,
                leads: [],
                agentName: "",
            }
        },
        mounted() {
            this.getDashboardLeads();
            // refresh ever 5 minutes
            this.timer = setInterval(this.getDashboardLeads, 300000);
        },
        beforeUnmount () {
            clearInterval(this.timer);
        },   
        watch: {
            agent() {
                this.getDashboardLeads();
            },
        },
        methods: {
            openAgentDashboard() {
                let route = this.$router.resolve({ path: "/pten/dashBoardPten" }); 
                window.open(route.href, "_self");
            },
            getDashboardLeads() {
                this.$axios.post("ares/json/ares/pten/getDashboardLeads.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getDashboardLeads",
                    },
                    getDashboardLeads: {
                        agent: (this.agent === null) ? "" : this.agent,
                    },
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.leads = res.data.getDashboardLeads;
                        this.agentName = res.data.user.agent;
                        this.loading = false;
                    }
                });
            },
        }
    }
</script>

<style scoped>
    .score-chart {
        background-image: linear-gradient(#00aaff, #88ffcc) !important;
        background-size: cover !important;
    }

    .br_medium {
        display: block;
        margin-bottom: 1em;
    }

    .caption-font {
        font-size: 30px;
        font-weight: bold;
    }

    .td_markup_xl {
        font-size: 17px !important;
        line-height: 25px !important;
    }
    .card_icon {
        background: transparent !important;
        font-size: 12px !important;
        font-weight: 600 !important;
        border: 2px solid white;
        color: white;
        cursor: default;
    }
</style>